import { render } from "./PostContent.vue?vue&type=template&id=6f5a21c7&scoped=true"
import script from "./PostContent.vue?vue&type=script&lang=js"
export * from "./PostContent.vue?vue&type=script&lang=js"

import "./PostContent.vue?vue&type=style&index=0&id=6f5a21c7&scoped=true&lang=css"

import exportComponent from "D:\\lawstudio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5a21c7"]])

export default __exports__